import React from 'react';
import { siteLinks } from '../content/siteContent';
import useSiteContent from '../hooks/useSiteContent';

export default function PricingPage() {
  const { siteContent } = useSiteContent();

  return (
    <main className="page">
      <section className="page-section page-section--intro">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{siteContent.pricingPage.tag}</span>
          <h1>{siteContent.pricingPage.title}</h1>
          <p>{siteContent.pricingPage.text}</p>
        </div>
      </section>

      <section className="page-section">
        <div className="card-grid card-grid--2">
          {siteContent.pricingPage.items.map((item) => (
            <article key={item.title} className="content-card pricing-card">
              <div className="content-card__body">
                <div className="pricing-card__header">
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                  <strong>{item.price}</strong>
                </div>
                <a className="button button--secondary" href={siteLinks.bookingUrl} target="_blank" rel="noopener noreferrer">
                  {siteContent.common.bookNow}
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="page-section split-grid">
        <article className="content-card">
          <div className="content-card__body">
            <span className="section-heading__eyebrow">{siteContent.pricingPage.touchUpsTitle}</span>
            <h2>{siteContent.pricingPage.touchUpsTitle}</h2>
            <p>{siteContent.pricingPage.touchUpsText}</p>
            <div className="stack-grid">
              {siteContent.pricingPage.touchUps.map((item) => (
                <div key={item.title} className="mini-card mini-card--soft">
                  <div className="pricing-card__header">
                    <h3>{item.title}</h3>
                    <strong>{item.price}</strong>
                  </div>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </article>

        <article className="content-card content-card--accent">
          <div className="content-card__body">
            <span className="section-heading__eyebrow">Brows Jungle</span>
            <h2>{siteContent.common.bookNow}</h2>
            <p>{siteContent.pricingPage.note}</p>
            <a className="button button--primary" href={siteLinks.bookingUrl} target="_blank" rel="noopener noreferrer">
              {siteContent.common.bookNow}
            </a>
          </div>
        </article>
      </section>
    </main>
  );
}
